import { Button, Tooltip } from '@ds';
import { KeyboardEventHandler, ReactNode } from 'react';
import { ResourceAvatar, ChipWithStatus } from '@ui';
import { OrganType, ResourceLogisticsStatus } from '@/api/apis/case';

type RouteResourceCardType = {
  hasResource: boolean;
  showAssignButton: boolean;
  organType?: OrganType;
  type?: 'device' | 'user' | 'clinical-specialist' | 'retrieval-surgeon';
  imageUrl?: string;
  title: string;
  statusType?: ResourceLogisticsStatus;
  status?: ResourceLogisticsStatus;
  subTitle?: string;
  statusText?: string;
  onOpen?: () => void;
  onClick?: () => void;
  children?: ReactNode;
};

export const RouteResourceCard = ({
  hasResource,
  imageUrl,
  type = 'clinical-specialist',
  title,
  statusType,
  statusText,
  subTitle,
  status,
  organType,
  showAssignButton,
  onOpen,
  onClick,
  children,
}: RouteResourceCardType) => {
  const onKeyPress: KeyboardEventHandler = (e) => {
    const enterOrSpace = e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar';
    if (enterOrSpace) {
      e.preventDefault();
      onClick?.();
    }
  };

  const divProps = status
    ? {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: onKeyPress,
      }
    : {};

  return (
    <div className="w-full h-20 p-2 gap-2 flex bg-base-70 rounded-md" {...divProps}>
      <ResourceAvatar
        size="md"
        radius="md"
        name={hasResource ? title : undefined}
        organ={organType}
        src={imageUrl}
        type={type}
      />
      <div className="min-w-0 grow flex flex-col items-start justify-between h-full">
        <div className="flex flex-col w-full">
          <span className="text-s-sb text-black truncate">{title}</span>
          {!!subTitle && <span className="text-s-r text-bae-10 truncate">{subTitle}</span>}
        </div>
        {hasResource && (
          <Tooltip className="p-0" content={<span className="px-2">{statusText}</span>}>
            <div>
              <ChipWithStatus variant="dot" size="xxs" color="secondary" status={statusType}>
                <span className="block overflow-hidden text-ellipsis whitespace-nowrap max-w-[120px]">
                  {statusText}
                </span>
              </ChipWithStatus>
            </div>
          </Tooltip>
        )}
        {showAssignButton && (
          <Button onClick={onOpen} variant="outline" size="sm">
            Reserve
          </Button>
        )}
      </div>
      {children && <div className="shrink-0">{children}</div>}
    </div>
  );
};
